export default __webpack_public_path__ + "static/media/cube_grad.54bfb759.svg";